import {Modal} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {PROFILE_AC_EMAIL} from '../../config/constants/routes';
import {useIsAppWebView} from '../hooks/useIsAppWebView';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const NotStudentVerifiedAlertModal: FC<Props> = (props) => {
  const isWebView = useIsAppWebView();
  const router = useRouter();

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      size="md"
      padding="md"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="text-center">
        <p className="mb-[20px]">
          大学認証が完了していないため、この機能はお使いになれません。
        </p>
      </div>
      <div className="flex justify-around">
        <BasicButton
          label="大学認証を完了する"
          isPrimary={true}
          className="mx-8"
          onClick={async () => {
            if (isWebView) {
              location.href = PROFILE_AC_EMAIL;
            } else {
              await router.push(PROFILE_AC_EMAIL);
            }
          }}
        />
      </div>
    </Modal>
  );
};
